module.exports = __webpack_public_path__ + "img/53.counter_handycap.b590e24a.svg";